import settings from './settings';
import axios from 'axios';

export async function checkUserCredentials(username, password){
  return axios.post(settings.endpoints.login, {username,password});
}
